import { styled } from "@mui/material";
const COLOR_PRIMARY = "#1886cf";

export const ContainerBg = styled("div")({
  zIndex: 3,
  background: "rgb(242, 242, 242)",
  boxShadow: `0 1px 5px rgba(0, 0, 0, 0.5),
              0 10px 12px rgba(0, 0, 0, 0.15),
              0 10px 45px rgba(0, 0, 0, 0),
              inset 0 1px 0 white,
              inset 0 -2px 0 rgba(0, 0, 0, 0.1)`,
  borderRadius: 10,
  padding: "20px 30px 30px",
  margin: "20px auto",
  display: "flex",
  flexFlow: "column",
  overflow: "hidden",
  position: "relative",
  fontSize: 15,
});

export const StyledTable = styled("table")(
  (props: { tableWithoutHover?: boolean; smTable?: boolean; noTextWrap?: boolean }) => {
    return {
      borderCollapse: "collapse",
      width: "100%",
      borderSpacing: 0,
      "& thead": {
        background: COLOR_PRIMARY,
        color: "white",
        fontWeight: "bold",
      },
      "& td": {
        padding: 5,
      },
      "& tbody td:hover": {
        cursor: "pointer",
      },
      "& tr:nth-of-type(even) td": {
        background: "rgba(128, 128, 128, 0.12)",
      },
      "& .hover": {
        background: "rgba(128, 128, 128, 0.4)",
        cursor: "pointer",
      },
      ...(props.tableWithoutHover && {
        "& tbody td:hover": {
          cursor: "default",
        },
      }),
      ...(props.smTable && {
        fontSize: 16,
        "& td": {
          padding: "2px 6px",
        },
        "@media (max-width: 1439px)": {
          fontSize: 12,
        },
        "@media (max-width: 1599px)": {
          fontSize: 13,
        },
        "@media (max-width: 1899px)": {
          fontSize: 14,
        },
      }),
      ...(props.noTextWrap && {
        textWrap: "nowrap",
      }),
    };
  }
);

export const StyledTdWithHover = styled("td")({
  "&:hover": {
    cursor: "pointer !important",
    background: "rgba(128, 128, 128, 0.4) !important",
  },
});
export const StyledTrWithHover = styled("tr")({
  "&:hover": {
    cursor: "pointer !important",
    background: "rgba(128, 128, 128, 0.4) !important",
  },
});
export const StyledTdNoWrap = styled("td")({
  whiteSpace: "nowrap",
});
export const StyledHorizontalScrollDiv = styled("div")({
  overflowX: "scroll",
  paddingBottom: 12,
  "& table": {
    width: "100%",
  },
});
